
import React from 'react';

interface BTBoxProps {
  width?: string | number;
  height?: string | number;
  backgroundColor?: string;
  margin?: string | number;
}

const addPx = (value: string | number): string =>
  typeof value === 'number' ? `${value}px` : value;

const BTBox: React.FC<BTBoxProps> = ({
  width = 10,
  height = 10,
  backgroundColor = 'transparent',
  margin = 0,
}) => {
  return (
    <div
      style={{
        width: addPx(width),
        height: addPx(height),
        backgroundColor,
        margin: addPx(margin),
      }}
    />
  );
};

export default BTBox;